// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__55zfW","bigColWidth":"Table_bigColWidth__3FE3o","biggerColWidth":"Table_biggerColWidth__3qfYE","row":"Table_row__31vDE","col":"Table_col__13ZHI"};